import { Lead, Paper } from '@/components/Layout/Layout'
import { useCopy } from '@/i18n/useCopy'
import styles from './Terms.module.css'

/**
 * Terms of service.
 *
 * NEEDS A LAWYER before this ships. The text says only things the code
 * actually does, and it is deliberately written in the same plain register as
 * the rest of the product rather than in legal boilerplate, but plain and
 * accurate is not the same as sufficient. Anything about liability, governing
 * law, dispute resolution or the age of consent in each market is missing on
 * purpose: those are not sentences to invent.
 *
 * The Hausa version carries the same caveat as the rest of the Hausa copy and
 * has not been read by a native speaker.
 *
 * The claims here are checked by `src/store/privacy.test.ts`, which asserts
 * each promise against the code rather than against a document. If a term
 * changes, that suite is where it has to stay true.
 */
export function TermsScreen() {
  const copy = useCopy()

  return (
    <Paper title={copy.ui.terms.title} backTo="/settings">
      <Lead>{copy.ui.terms.lead}</Lead>
      <p className={styles.updated}>{copy.ui.terms.updated}</p>

      {copy.ui.terms.sections.map((section) => (
        <section className={styles.section} key={section.heading}>
          <h2 className={styles.heading}>{section.heading}</h2>
          <p className={styles.body}>{section.body}</p>
        </section>
      ))}
    </Paper>
  )
}
